import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies on a secure httpOnly cookie set by the backend (sent via withCredentials).
// The JWT is never persisted in localStorage; it is only kept in memory for the current
// session as an Authorization header fallback, and is lost on reload (cookie re-authenticates).
const api = axios.create({ baseURL: API, withCredentials: true });

export function setToken(token) {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
}

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Възникна грешка";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const money = (n) => `${Number(n || 0).toFixed(2)} €`;

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const moveIds = (items, idx, dir) => {
  const ids = items.map((x) => x.id);
  const j = idx + dir;
  if (j < 0 || j >= ids.length) return null;
  [ids[idx], ids[j]] = [ids[j], ids[idx]];
  return ids;
};

export default api;
